module.exports = "/dist/d2f4cde6a312ff5c6160ac36c1f443b2.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600italic.eot
// module id = 17
// module chunks = 0